export default __webpack_public_path__ + "static/media/04.46523e7d.jpg";